// MUI
import { Stepper, Step, StepLabel } from '@mui/material'

// Components
import Header from 'components/molecules/Header/Header'
import AlertDialog from 'components/AlertDialog/AlertDialog'
import LeaveDialog from 'components/LeaveDialog/LeaveDialog'

import styles from './Receive.module.scss'

import { useReceiveWorkflowLogic } from './Receive.logic'
import { useReceivingStore } from 'store/receiving'

import OwnershipSelection from './workflow/OwnershipSelection'
import ProductTypeSelection from './workflow/ProductTypeSelection'
import ScanStep from './workflow/ScanStep'
import ReviewStep from './workflow/ReviewStep'

const ReceiveWorkflowContent = () => {
  const {
    activeStep,
    steps,
    isDiscardAlertOpen,
    handleStepClick,
    handleNextStep,
    handlePreviousStep,
    handleDiscardWorkflow,
    handleLeaveWorkflow,
    setIsDiscardAlertOpen,
  } = useReceiveWorkflowLogic()

  const isNavigationBlocked = useReceivingStore((s) => s.isNavigationBlocked)

  const renderStepContent = (step: number) => {
    switch (step) {
      case 0:
        return <OwnershipSelection onNext={handleNextStep} />
      case 1:
        return (
          <ProductTypeSelection
            onNext={handleNextStep}
            onBack={handlePreviousStep}
          />
        )
      case 2:
        return <ScanStep onNext={handleNextStep} onBack={handlePreviousStep} />
      case 3:
        return (
          <ReviewStep onNext={handleNextStep} onBack={handlePreviousStep} />
        )
      default:
        return null
    }
  }

  return (
    <div className={styles.receivingWorkflowContainer}>
      <Header title="Receiving Products" parent="Receiving" hasBack={false} />

      <div className={styles.stepLayoutHeader}>
        <Stepper activeStep={activeStep} className={styles.stepper}>
          {steps.map((label, index) => (
            <Step
              key={label}
              completed={index < activeStep}
              onClick={() => handleStepClick(index)}
            >
              <StepLabel
                classes={{
                  root: styles.stepRoot,
                  label: styles.stepLabel,
                  labelContainer: styles.stepLabelContainer,
                }}
              >
                {label}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      </div>

      <div className={styles.stepperContent}>
        {renderStepContent(activeStep)}
      </div>

      <AlertDialog
        isOpen={isDiscardAlertOpen}
        mode="warning"
        title="Discard Receiving Process?"
        description="Are you sure you want to exit the receiving workflow? All progress will be lost."
        secondaryButtonText="Cancel"
        secondaryButtonAction={() => setIsDiscardAlertOpen(false)}
        primaryButtonText="Discard"
        primaryButtonAction={handleDiscardWorkflow}
        zIndex={999}
      />

      <LeaveDialog
        isNavigationBlocked={isNavigationBlocked}
        onLeave={handleLeaveWorkflow}
        title="Discard Receiving Process?"
        description="Leaving will discard all your current progress. Are you sure you want to leave?"
      />
    </div>
  )
}

const Receive = () => <ReceiveWorkflowContent />

export default Receive
